<template class="py-5">
  <b-container>
    <b-row class="justify-content-center">
      <b-col cols="8">
        <b-card class="p-4 shadow-sm border">
          <div class="text-center mb-4">
            <h4>Reservation Request</h4>
            <p class="mb-0"><strong>Project Name:</strong> {{ detail_project_name }}</p>
            <small class="text-muted">Tanggal: {{ detail_date }} - Jam: {{ detail_time }}</small>
          </div>
  
          <b-row>
            <b-col cols="6">
              <p><strong>AM Name:</strong> {{ detail_am_name }}</p>
              <p><strong>Segment/Witel:</strong> {{ detail_segmen_witel }}</p>
              <p><strong>Phone Number:</strong> {{ detail_phone_number }}</p>
              <p><strong>Customer Name:</strong> {{ detail_customer_name }}</p>
              <div v-if="Array.isArray(detail_product_category)">
                <template v-for="(item, index) in detail_product_category">
                  <p v-if="index === 0"><strong>Portfolio:</strong> {{ item }}</p>
                  <p v-else><strong>Portfolio {{ toRoman(index + 1) }}:</strong> {{ item }}</p>
                </template>
              </div>
              <p v-else><strong>Portfolio:</strong> {{ detail_product_category }}</p>

            </b-col>
  
            <b-col cols="6">
              <p><strong>NIK:</strong> {{ detail_nik }}</p>
              <p><strong>Division/TREG:</strong> {{ detail_division_treg }}</p>
              <p><strong>Email:</strong> {{ detail_email }}</p>
              <p><strong>Project Status:</strong> {{ detail_project_status }}</p>
              <div v-if="Array.isArray(detail_product_name)">
                <template v-for="(item, index) in detail_product_name">
                  <p v-if="index === 0"><strong>Product Name:</strong> {{ item }}</p>
                  <p v-else><strong>Product Name {{ toRoman(index + 1) }}:</strong> {{ item }}</p>
                </template>
              </div>
              <p v-else><strong>Product Name:</strong> {{ detail_product_name }}</p>

            </b-col>
          </b-row>
  
          <hr />
  
          <b-row class="mb-3">
            <b-col>
              <p><strong>Notes:</strong></p>
              <div class="border p-3 rounded bg-light">
                {{ detail_note }}
              </div>
            </b-col>
          </b-row>
  
          <hr />
  
          <b-row class="mb-3">
            <b-col v-if="statusNow === 'REQUESTED'">
              <div class="text-center mb-2">
                <h4>Responding to Reservation Requests for Approved</h4>
              </div>
              <b-form @submit="onSubmit">
                <b-row>
                  <!-- NOTES -->
                  <b-col md="12">
                    <b-form-group label="Notes">
                      <b-form-textarea
                        v-model="form.notes"
                        id="notes"
                        placeholder="Ex. "
                        rows="3"
                      />
                    </b-form-group>
                  </b-col>
  
                  <!-- SUBMIT -->
                  <b-col class="d-flex justify-content-end">
                    <b-button
                      variant="primary"
                      :to="{ name: 'admin-reservation-request' }"
                      class="d-inline-flex align-items-center mr-1"
                    >
                      <feather-icon icon="ChevronLeftIcon" size="18" class="mr-1" />
                      <span>Back</span>
                    </b-button>
                    <b-button variant="primary" type="submit" :disabled="isLoading">Submit</b-button>
                  </b-col>
                </b-row>
              </b-form>
            </b-col>
            <b-col class="text-center py-5" v-else>
              <feather-icon icon="CheckCircleIcon" size="64" class="text-success mb-3" />
              <h3 class="font-weight-bold text-dark">{{ statusNow }}</h3>
              <p class="text-muted mb-4" v-if="statusNow === 'APPROVED'">
                This reservation has been approved
              </p>
              <p class="text-muted mb-4" v-else-if="statusNow === 'RESCHEDULE'">
                This reservation has been reschedule
              </p>
              <p class="text-muted mb-4" v-else-if="statusNow === 'DELETED'">
                This reservation has been deleted by the user
              </p>
      
              <b-button
                variant="primary"
                :to="{ name: 'home' }"
                class="d-inline-flex align-items-center mx-auto"
              >
                <feather-icon icon="ChevronLeftIcon" size="18" class="mr-1" />
                <span>Back to Home</span>
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {
  BSpinner,
  BCard,
  BRow,
  BCol,
  BFormCheckbox,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormDatepicker,
  BFormTextarea,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import DatePicker from 'vue2-datepicker'
import Ripple from 'vue-ripple-directive'
import moment from "moment";
import { generateToken } from '@/auth/helperAuth'

export default {
  components: {
    BSpinner,
    BCard,
    BRow,
    BCol,
    BFormCheckbox,
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    vSelect,
    BFormSelect,
    BFormDatepicker,
    DatePicker,
    moment,
  },
  data() {
    return {
      token: "",
      isLoading: false,
      statusNow: 'REQUESTED',
      detail_am_name: '',
      detail_customer_name: '',
      detail_division_treg: '',
      detail_email: '',
      detail_date: '',
      detail_nik: '',
      detail_note: '',
      detail_phone_number: '',
      detail_product_category: '',
      detail_product_name: '',
      detail_project_name: '',
      detail_project_status: '',
      detail_segmen_witel: '',
      detail_time: '',
      form: {
        id: 0,
        request_status: '',
        date: null,
        time: '',
        notes: '',
      },
      usedDates: [],
      dateTouched: false
    }
  },

  directives: {
    Ripple,
  },

  created() {
    const payload = {
      client: "product-catalog-fe",
      kode: this.$store.getters['oauth/getActiveUser'].id.toString(),
      user: this.$store.getters['oauth/getActiveUser'].name,
      role: this.$store.getters['oauth/getActiveUser'].role,
    };
    this.token = generateToken(payload)
  },

  mounted() {
    this.fetchUsedDates();
    const data = JSON.parse(Buffer.from(this.$route.params.data, "base64").toString("utf-8"))
    this.form.id = data.id
    this.detail_am_name = data.am_name
    this.detail_customer_name = data.customer_name
    this.detail_division_treg = data.division_treg
    this.detail_email = data.email
    this.detail_nik = data.nik
    this.detail_note = data.note
    this.detail_phone_number = data.phone_number
    this.detail_product_category = data.product_category
    this.detail_product_name = data.product_name
    this.detail_project_name = data.project_name
    this.detail_project_status = data.project_status
    this.detail_segmen_witel = data.segmen_witel
    this.detail_time = data.time
    this.detail_date = data.date
    this.form.request_status = 'APPROVED'
    this.$http.get(`${process.env.VUE_APP_API_HELPER_URL}/internal/data?table=consultative_selling&id=`+data.id, {
      params: {},
      withCredentials: true,
      headers: { 'Client-Device': 'browser', 'Authorization': `${this.token}` },
    }).then(({ data }) => {
      this.statusNow = data.request_status
      if (data.is_deleted) {
        this.statusNow = 'DELETED'
      }
    }).finally(() => {
      this.isBusy = false
    })
  },
  methods: {
    fetchUsedDates() {
      // this.$http.get(`http://localhost:9999/consultativeSelling/dateTime`, {
      this.$http.get(`${process.env.VUE_APP_API_HELPER_URL}/consultativeSelling/dateTime`, {
        withCredentials: true,
        headers: { 'Client-Device': 'browser', 'Authorization': `${this.token}` },
      })
        .then((data) => {
          const response = data.data
          this.usedDates = [
            ...new Set(
              response
                .map(item => item.date)
                .filter(date => /^\d{4}-\d{2}-\d{2}$/.test(date)) // hanya format valid
            )
          ];
        })
        .catch(error => {
          this.$notif('Error', `${error.data.message}`, 'error')
        })
    },
    toRoman(num) {
      const roman = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X']
      return roman[num - 1] || num
    },
    onSubmit(event) {
      event.preventDefault()
      this.dateTouched = true;

      const requestData = {
        id: this.form.id,
        request_status: this.form.request_status,
        approve_note: this.form.notes,
        reschedule_note: null,
        date_rescheduled_to: null,
        time_rescheduled_to: null,
      }
      this.isLoading = true
      // this.$http.put(`http://localhost:9999/consultativeSelling/updateStatus`, requestData, {
      this.$http.put(`${process.env.VUE_APP_API_HELPER_URL}/consultativeSelling/updateStatus`, requestData, {
        withCredentials: true,
        headers: { 'Client-Device': 'browser', 'Authorization': `${this.token}` },
      })
        .then(() => {
          this.$notif('Success', 'Request has been successfully added.', 'success')
          this.$router.push({ name: 'admin-reservation-request' })
        })
        .catch(error => {
          this.$notif('Error', `${error.data.message}`, 'error')
        })
    },
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

  html, body {
    max-width: 100%;
    overflow-x: hidden;
  }
</style>
